/*
 * Project: BookingEngine
 * Module: components/common/Breadcrumbs.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withNavigate from '../../withNavigate'; // Importa el HOC

import { BOOKING_STEP, DEVICES } from '../../actions/Booking';

import CheckIcon from '../icons/CheckIcon';
import '../../static/less/layout/breadcrumbs.less';

const STEP_IDS = Object.keys(BOOKING_STEP);

const isAvailableStep = (step, isFreeMode) => {
  switch (step.mode) {
    case 'rooms':
      return !isFreeMode;
    case 'all-rooms':
      return isFreeMode;
    case 'both':
    default:
      return true;
  }
};

class Breadcrumbs extends React.Component {
  constructor(props) {
    super(props);

    this.onStepClick = this.onStepClick.bind(this);
  }

  onStepClick(step) {
    this.props.navigate(step.path);
  }

  buildStep(step, index, type) {
    return (
      <li className={`step ${type}`} key={`${type}Step${index}`} onClick={() => this.onStepClick(step)}>
        {type === 'completed' && <span className="check-mark"><CheckIcon /></span>}
        <span className="step__number">{index}</span><span className="step__name">.&nbsp;{step.text}</span>
      </li>
    );
  }

  getAvailableSteps() {
    return [
      {
        id: BOOKING_STEP.CHOOSE, text: this.context.t('Select'), mode: 'rooms', path: '/rooms/',
      },
      {
        id: BOOKING_STEP.CHOOSE, text: this.context.t('Select'), mode: 'all-rooms', path: '/all-rooms/',
      },
      {
        id: BOOKING_STEP.CONFIRM, text: this.context.t('Book'), mode: 'both', path: '/confirmation/',
      },
    ].filter((step) => isAvailableStep(step, this.props.isFreeModeSelected));
  }

  buildSteps() {
    return this.getAvailableSteps().map((step, index) => {
      const currentStepIdx = STEP_IDS.findIndex((id) => id === this.props.currentStepId);
      let stepType;
      if (index === currentStepIdx - 1) {
        stepType = 'selected';
      } else if (index < currentStepIdx - 1) {
        stepType = 'completed';
      } else {
        stepType = 'next';
      }
      return this.buildStep(step, index + 1, stepType);
    });
  }

  render() {
    // The breadcrumb is not shown in "NO_AVAIL" steps
    if (this.props.currentStepId === BOOKING_STEP.NO_AVAIL_STEP) {
      return null;
    }
    return (
      <ul className={`Breadcrumbs ${this.props.isMobile === true
        && this.props.shouldShowNewShoppingCartMobileHeader === true
        ? 'marginTopOpenReservationDetailsBreadbumbs' : ''}`}>
        {this.buildSteps()}
      </ul>
    );
  }
}

Breadcrumbs.contextTypes = {
  t: PropTypes.func.isRequired,
};

Breadcrumbs.propTypes = {
  currentStepId: PropTypes.oneOf(STEP_IDS).isRequired,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  lang: state.i18nState.lang, // required so that the labels are re-rendered
  isFreeModeSelected: state.bookingFormState.isFreeModeSelected,
  currentStepId: state.booking.step,
  hotel: state.booking.hotel,
  openReservationDetails: state.session.openReservationDetails,
  shouldShowNewShoppingCartMobileHeader: !!(window.location.pathname === '/rooms/'
    || window.location.pathname === '/confirmation/'),
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
});

const ConnectedBreadcrumbs = connect(mapStateToProps)(Breadcrumbs);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedBreadcrumbs);
